// copy-paste from theme assets/product-form.js

export const ConvermaxProductForm = class extends window.HTMLElement {
  constructor() {
    super();

    setTimeout(() => {
      this.form = this.querySelector('form');
      this.submitButton = this.querySelector('[type="submit"]');
      // PLP cards render an <a href> "Shop now" link instead of a submit
      // button, and sold-out/coming-soon variants can omit the form
      // entirely. Without both elements this class has nothing to wire
      // up, so bail out before dereferencing null.
      if (!this.form || !this.submitButton) {
        return;
      }

      this.variantIdInput.disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartDrawer = document.querySelector('cart-drawer');
      this.cartItems = document.querySelector('cart-items');
      this.cartNotification = document.querySelector('cart-notification');
      this.submitButtonText = this.submitButton.querySelector('span');

      if (this.cartDrawer) {
        customElements.whenDefined('cart-drawer').then(() => {
          this.cartDrawer.init?.();
        });
      }

      if (this.cartNotification) {
        window.loadTemplateContent(this.cartNotification);
        customElements.whenDefined('cart-notification').then(() => {
          this.cartNotification.init?.();
        });
      }

      if (this.cartDrawer) {
        this.submitButton.setAttribute('aria-haspopup', 'dialog');
      }

      this.hideErrors = this.dataset.hideErrors === 'true';
    }, 0);
  }

  onSubmitHandler(evt) {
    evt.preventDefault();
    if (this.submitButton.getAttribute('aria-disabled') === 'true') {
      return;
    }

    this.handleErrorMessage();

    this.submitButton.setAttribute('aria-disabled', true);
    this.submitButton.classList.add('loading');
    this.querySelector('.loading__spinner').classList.remove('hidden');

    const config = window.fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    const formData = new FormData(this.form);
    let sections = [];
    if (this.cartDrawer) {
      sections = [...sections, ...this.cartDrawer.getSectionsToRender().map((section) => section.id)];
    }
    if (this.cartNotification) {
      window.loadTemplateContent(this.cartNotification);
      sections = [...sections, ...this.cartNotification.getSectionsToRender().map((section) => section.id)];
    }
    if (this.cartItems) {
      sections = [...sections, ...this.cartItems.getSectionsToRender().map((section) => section.section)];
    }
    if (sections.length > 0) {
      formData.append('sections', [...new Set(sections)]);
      formData.append('sections_url', window.location.pathname);
      if (this.cartDrawer) {
        this.cartDrawer.setActiveElement(document.activeElement);
      } else if (this.cartNotification) {
        this.cartNotification.setActiveElement(document.activeElement);
      }
    }
    config.body = formData;

    fetch(`${window.routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          window.publish('cart-error', {
            source: 'product-form',
            productVariantId: formData.get('id'),
            errors: response.errors || response.description,
            message: response.message,
          });
          this.handleErrorMessage(response.description);

          const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
          if (!soldOutMessage) {
            return;
          }
          this.submitButton.setAttribute('aria-disabled', true);
          this.submitButtonText.classList.add('hidden');
          soldOutMessage.classList.remove('hidden');
          this.error = true;
          return;
        } else if (!this.cartDrawer && !this.cartItems && !this.cartNotification) {
          window.location = window.routes.cart_url;
          return;
        }

        if (!this.error) {
          window.publish('cart-update', {
            source: 'product-form',
            productVariantId: formData.get('id'),
            cartData: response,
          });
        }
        this.error = false;
        const quickAddModal = this.closest('quick-add-modal');
        if (quickAddModal) {
          document.body.addEventListener(
            'modalClosed',
            () => {
              setTimeout(() => {
                this.cartDrawer?.renderContents(response);
                this.cartItems?.renderContents(response);
                this.cartNotification?.renderContents(response);
              });
            },
            { once: true },
          );
          quickAddModal.hide(true);
        } else {
          this.cartDrawer?.renderContents(response);
          this.cartItems?.renderContents(response);
          this.cartNotification?.renderContents(response);
        }
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        this.submitButton.classList.remove('loading');
        if (this.cartDrawer?.classList.contains('is-empty')) {
          this.cartDrawer.classList.remove('is-empty');
        }
        if (this.cartNotification?.classList.contains('is-empty')) {
          this.cartNotification.classList.remove('is-empty');
        }
        if (!this.error) {
          this.submitButton.removeAttribute('aria-disabled');
        }
        this.querySelector('.loading__spinner').classList.add('hidden');
      });
  }

  handleErrorMessage(errorMessage = false) {
    if (this.hideErrors) {
      return;
    }

    this.errorMessageWrapper =
      this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
    if (!this.errorMessageWrapper) {
      return;
    }
    this.errorMessage =
      this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

    this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

    if (errorMessage) {
      this.errorMessage.textContent = errorMessage;
    }
  }

  toggleSubmitButton(disable = true, text) {
    if (disable) {
      this.submitButton.setAttribute('disabled', 'disabled');
      if (text) {
        this.submitButtonText.textContent = text;
      }
    } else {
      this.submitButton.removeAttribute('disabled');
      this.submitButtonText.textContent = window.variantStrings.addToCart;
    }
  }

  get variantIdInput() {
    return this.form.querySelector('[name=id]');
  }
};
